import replaceDomain from "../../utils/replaceDomain";

// services/mappers/floor.js
export const setFloors = (el = {}) => ({
  createdAt: el?.CreatedAt || null,
  updatedAt: el?.UpdatedAt || null,
  deletedAt: el?.DeletedAt || null,
  id: el?.ID || null,
  campus_id: el?.campus_id || null,
  floor_plan_url: replaceDomain(el.floor_plan_url),
  label: el?.label || "",
  level: el?.level || 0,
  isRoof: el?.is_roof || false,
});
